module.exports = __webpack_public_path__ + "img/alejandro-orestano.7ccc3e8d.png";